// extracted by mini-css-extract-plugin
export default {"root":"NoData_root__UlptZ","title":"NoData_title__R7Un-"};